import {
  ACTION_LOAD_PAYOUT_REQUEST_AVAILABILITY__REQUEST,
  ACTION_LOAD_PAYOUT_REQUEST_AVAILABILITY__SUCCESS,
  ACTION_LOAD_PAYOUT_REQUEST_AVAILABILITY__FAIL,
} from '../../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_PAYOUT_REQUEST_AVAILABILITY__REQUEST:
    case ACTION_LOAD_PAYOUT_REQUEST_AVAILABILITY__SUCCESS:
      return null;

    case ACTION_LOAD_PAYOUT_REQUEST_AVAILABILITY__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
